(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-final-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sp-footer-video')) {
  customElements.define('sp-footer-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.closest('footer').querySelector('[data-sp-footer-motion]');
      this.video = this.querySelector('video');
      this.visible = false;
      this.userPaused = false;
      this.button?.addEventListener('click', () => {
        this.userPaused = Boolean(this.video && !this.video.paused);
        this.updatePlayback();
      }, options);
      this.motion.addEventListener('change', () => this.updatePlayback(), options);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.updatePlayback();
        });
        this.observer.observe(this);
      }
    }
    updatePlayback() {
      const disabled = this.motion.matches || navigator.connection?.saveData;
      if (this.button) this.button.hidden = disabled || !this.visible;
      if (disabled || !this.visible || document.hidden || this.userPaused) {
        this.video?.pause();
        this.updateControl();
        return;
      }
      if (!this.video) {
        const template = this.querySelector('[data-sp-footer-video]');
        if (!(template instanceof HTMLTemplateElement)) return;
        template.replaceWith(template.content.cloneNode(true));
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.tabIndex = -1;
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-loaded', '');
          this.updateControl();
        }, { signal: this.controller.signal });
        this.video.addEventListener('pause', () => this.updateControl(), { signal: this.controller.signal });
      }
      this.video.play().catch(() => this.updateControl());
    }
    updateControl() {
      if (!this.button) return;
      const paused = !this.video || this.video.paused;
      this.button.setAttribute('aria-pressed', String(paused));
      this.button.querySelector('[data-sp-footer-pause]').hidden = paused;
      this.button.querySelector('[data-sp-footer-play]').hidden = !paused;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-skin-health"] && !Shopify.designMode) return;
  try {
    
  window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
    document.querySelectorAll('.sp-skin-health .sh-doctor-video').forEach((container) => {
      if (getComputedStyle(container).display === 'none') container.querySelector('video')?.pause();
    });
  });
  const stickyBars = new WeakMap();
  function initializeStickyBuy() {
    document.querySelectorAll('.sp-skin-health').forEach((root) => {
      if (stickyBars.has(root)) return;
      const hero = root.querySelector('.hero-v2');
      const source = root.querySelector('.hero-v2__cta');
      if (!hero || !source) return;
      const bar = document.createElement('aside');
      bar.className = 'sh-sticky-buy';
      bar.setAttribute('aria-label', 'Shop Sun Powder');
      bar.hidden = true;
      const inner = document.createElement('div');
      inner.className = 'sh-sticky-buy__inner';
      const link = source.cloneNode(true);
      link.className = 'btn';
      link.textContent = 'Try Sun Powder';
      const note = document.createElement('p');
      note.textContent = '90-day supply';
      const savings = document.createElement('span');
      savings.className = 'sh-sticky-buy__savings';
      savings.textContent = 'Subscribe & save 30%';
      savings.title = 'Rounded savings: $183 vs. three separate $79 one-time orders, each with $8 shipping ($261 total).';
      note.append(savings);
      inner.append(link, note);
      bar.append(inner);
      root.append(bar);
      stickyBars.set(root, { hero, bar });
    });
    scheduleStickyBuy();
  }
  let stickyFrame = 0;
  function scheduleStickyBuy() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => {
      stickyFrame = 0;
      const target = document.querySelector('[id^="shopify-section-"][id*="featured_product_information"]');
      const modalOpen = !!document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])');
      document.querySelectorAll('.sp-skin-health').forEach((root) => {
        const state = stickyBars.get(root);
        if (!state) return;
        state.bar.hidden = !target || state.hero.getBoundingClientRect().bottom > 0 ||
          target.getBoundingClientRect().top < innerHeight || modalOpen;
      });
    });
  }
  window.addEventListener('scroll', scheduleStickyBuy, { passive:true });
  window.addEventListener('resize', scheduleStickyBuy, { passive:true });
  document.addEventListener('click', scheduleStickyBuy);
  document.addEventListener('close', scheduleStickyBuy, true);
  document.addEventListener('shopify:section:load', initializeStickyBuy);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStickyBuy, { once:true });
  } else {
    initializeStickyBuy();
  }
  function initializeReviewCarousels() {
    document.querySelectorAll('.sp-skin-health .sh-review-carousel').forEach((carousel) => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const slides = [...carousel.querySelectorAll('.sh-review-slide')];
      let index = 0;
      carousel.querySelector('.sh-review-controls').hidden = false;
      carousel.querySelectorAll('[data-review-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          index = (index + Number(button.dataset.reviewDirection) + slides.length) % slides.length;
          slides.forEach((slide, position) => { slide.hidden = position !== index; });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReviewCarousels, { once:true });
  } else {
    initializeReviewCarousels();
  }
  document.addEventListener('shopify:section:load', initializeReviewCarousels);
  let timelineFrame = 0;
  function updateTimelineProgress() {
    timelineFrame = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const readingLine = window.innerHeight * 0.6;
    document.querySelectorAll('.sp-skin-health .benefits-timeline__item').forEach((item) => {
      const bounds = item.getBoundingClientRect();
      const icon = item.querySelector('.benefits-timeline__icon');
      const iconHeight = icon.getBoundingClientRect().height;
      const start = bounds.top + iconHeight + 8;
      const progress = reducedMotion ? 1 : Math.max(0, Math.min(1, (readingLine - start) / Math.max(1, bounds.bottom - start)));
      item.style.setProperty('--timeline-progress', progress.toFixed(4));
      item.classList.toggle('is-passed', reducedMotion || readingLine >= bounds.top + iconHeight / 2);
    });
  }
  function scheduleTimelineProgress() {
    if (!timelineFrame) timelineFrame = window.requestAnimationFrame(updateTimelineProgress);
  }
  window.addEventListener('scroll', scheduleTimelineProgress, { passive:true });
  window.addEventListener('resize', scheduleTimelineProgress, { passive:true });
  window.addEventListener('load', scheduleTimelineProgress, { once:true });
  document.addEventListener('shopify:section:load', scheduleTimelineProgress);
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', scheduleTimelineProgress);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleTimelineProgress, { once:true });
  } else {
    scheduleTimelineProgress();
  }
  const initializedBenefitGroups = new WeakSet();
  function initializeBenefitReveals() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.sp-skin-health .sh-drink-photo .hero-bleed__callouts').forEach((group) => {
      if (initializedBenefitGroups.has(group)) return;
      initializedBenefitGroups.add(group);
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          group.classList.add('sh-benefits-visible');
          observer.disconnect();
        }
      }, { threshold:0.2 });
      observer.observe(group);
      group.classList.add('sh-benefits-ready');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBenefitReveals, { once:true });
  } else {
    initializeBenefitReveals();
  }
  document.addEventListener('shopify:section:load', initializeBenefitReveals);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sp-skin-health .sh-podcasts__toggle');
    if (!button) return;
    const section = button.closest('.sh-podcasts');
    const paused = section.dataset.paused !== 'true';
    section.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    const label = paused ? 'Resume podcast scrolling' : 'Pause podcast scrolling';
    button.setAttribute('aria-label', label);
    button.title = label;
  });
  const initializedIngredientDecks = new WeakSet();
  function initializeIngredientDecks() {
    document.querySelectorAll('.sp-skin-health .ingredient-deck').forEach((deck) => {
      const nav = deck.nextElementSibling;
      const prev = nav.querySelector('.ingredient-deck__nav--prev');
      const next = nav.querySelector('.ingredient-deck__nav--next');
      const thumb = nav.querySelector('.ingredient-deck__indicator-thumb');
      const update = () => {
        const max = deck.scrollWidth - deck.clientWidth;
        const progress = max > 0 ? Math.max(0, Math.min(1, deck.scrollLeft / max)) : 0;
        thumb.style.transform = 'translateX(' + progress * 200 + '%)';
        prev.disabled = deck.scrollLeft <= 1;
        next.disabled = deck.scrollLeft >= max - 1;
      };
      if (!initializedIngredientDecks.has(deck)) {
        initializedIngredientDecks.add(deck);
        const move = (direction) => {
          const slide = deck.querySelector('.ingredient-deck__slide');
          const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(deck).columnGap);
          deck.scrollBy({
            left: step * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        deck.addEventListener('scroll', update, { passive: true });
      }
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeIngredientDecks, { once: true });
  } else {
    initializeIngredientDecks();
  }
  window.addEventListener('resize', initializeIngredientDecks, { passive: true });
  document.addEventListener('shopify:section:load', initializeIngredientDecks);
  const initializedDermTracks = new WeakSet();
  function updateDermIndicator(track) {
    const indicator = track.parentElement.querySelector('.derm-cards__indicator');
    const thumb = indicator.querySelector('.derm-cards__indicator-thumb');
    const maxScroll = track.scrollWidth - track.clientWidth;
    indicator.hidden = maxScroll <= 1;
    if (maxScroll <= 1) return;
    const width = indicator.clientWidth * track.clientWidth / track.scrollWidth;
    const progress = Math.max(0, Math.min(1, track.scrollLeft / maxScroll));
    thumb.style.width = `${width}px`;
    thumb.style.transform = `translateX(${progress * (indicator.clientWidth - width)}px)`;
  }
  function initializeDermTracks() {
    document.querySelectorAll('.sp-skin-health .derm-cards__track').forEach((track) => {
      if (!initializedDermTracks.has(track)) {
        initializedDermTracks.add(track);
        track.addEventListener('scroll', () => updateDermIndicator(track), { passive: true });
      }
      updateDermIndicator(track);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDermTracks, { once: true });
  } else {
    initializeDermTracks();
  }
  window.addEventListener('resize', initializeDermTracks, { passive: true });
  document.addEventListener('shopify:section:load', initializeDermTracks);
  const initializedCharts = new WeakSet();
  function initializeSkinHealthCharts() {
    document.querySelectorAll('.sp-skin-health .results-chart').forEach((chart) => {
      if (initializedCharts.has(chart)) return;
      initializedCharts.add(chart);
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        chart.classList.add('is-visible');
        return;
      }
      chart.setAttribute('data-sh-chart-ready', '');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          chart.classList.add('is-visible');
          observer.disconnect();
        }
      }, { threshold: 0.25 });
      observer.observe(chart);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSkinHealthCharts, { once: true });
  } else {
    initializeSkinHealthCharts();
  }
  document.addEventListener('shopify:section:load', initializeSkinHealthCharts);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sh-buy]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.querySelector('[id^="shopify-section-"][id*="featured_product_information"]');
    if (!target) return;
    event.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 70, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
